import React from 'react';
import { Helmet } from 'react-helmet'; // Import Helmet
import Home1 from '../../Components/Home/Head';
import Boxteam from '../../Components/Home/boxteam';
import Helpyou from '../../Components/Home/helpyou';
import Why from '../../Components/Home/why';
import Appraisal from '../../Components/Home/appraisal';
import Worktogether from '../../Components/Home/worktogether';
import Propertycards from '../../Components/Home/OngoingProperties';
import Assestclass from '../../Components/Home/AssestClass';
import Properties from '../../Properties/property.json';
import Future from '../../Components/Home/Future';
import Benefits from '../../Components/Home/Benefits';
import Wfractional from '../../Components/Home/WFractional';

const Version1 = () => {
    return (
        <div>
            <Helmet>
                <title>Smart Real Estate Investment with Fractional Ownership | CoOwnSpace</title>
                <meta name="description" content="CoOwnSpace Fractional ownership: The future of real estate. Invest smarter, own effortlessly! CoOwnSpace’s fractional ownership model provides steady rental income & long-term appreciation. Invest in low-risk real estate with a minimal budget." /> {/* Description */}
                <meta name="keywords" content="CoOwnSpace, fractional ownership, real estate investment, property investment, smart investment, rental income, low-risk real estate" /> {/* Optional keywords */}
                <meta property="og:title" content="CoOwnSpace - Future of Real Estate" />
                <meta property="og:description" content="CoOwnSpace’s fractional ownership model provides steady rental income & long-term appreciation. Invest in low-risk real estate with a minimal budget." /> {/* Open Graph Description */}
                <meta property="og:image" content="URL_to_image" />
                <meta property="og:url" content="https://www.cownspace.com" />
            </Helmet>
            <Home1 />
            <Wfractional />
            <Benefits />
            <Boxteam />
            <Helpyou />
            <Why />
            <Appraisal />
            <Propertycards propertiesData={Properties} />
            <Future />
            <Assestclass />
            <Worktogether />
        </div>
    );
}

export default Version1;
